import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const workerStats = {
  labels: ['Ingestion', 'OCR', 'NLP', 'Indexing'],
  datasets: [
    { label: 'Успешно', data: [120, 115, 110, 108], backgroundColor: '#22c55e', borderRadius: 4 },
    { label: 'Ошибки', data: [2, 5, 3, 1], backgroundColor: '#ef4444', borderRadius: 4 },
  ],
};

const ingestionLog = [
  { id: '1', source: 'publication.pravo.gov.ru', eo: 'EO-892', action: 'download', status: 'success', details: 'PDF 2.4MB', time: '2026-06-01 01:42:15' },
  { id: '2', source: 'publication.pravo.gov.ru', eo: 'EO-156-ФЗ', action: 'download', status: 'success', details: 'PDF 1.8MB', time: '2026-06-01 01:30:22' },
  { id: '3', source: 'publication.pravo.gov.ru', eo: 'EO-342н', action: 'ocr', status: 'processing', details: 'Page 3/12', time: '2026-06-01 01:28:10' },
  { id: '4', source: 'publication.pravo.gov.ru', eo: 'EO-891', action: 'nlp', status: 'processing', details: 'Extracting entities...', time: '2026-06-01 01:15:45' },
  { id: '5', source: 'publication.pravo.gov.ru', eo: 'EO-155-ФЗ', action: 'index', status: 'success', details: 'Indexed in 120ms', time: '2026-06-01 01:10:00' },
  { id: '6', source: 'publication.pravo.gov.ru', eo: 'EO-890', action: 'download', status: 'error', details: 'Connection timeout', time: '2026-06-01 00:58:33' },
  { id: '7', source: 'actual.pravo.gov.ru', eo: 'EO-889', action: 'parse', status: 'success', details: 'HTML parsed', time: '2026-06-01 00:45:12' },
  { id: '8', source: 'publication.pravo.gov.ru', eo: 'EO-888', action: 'ocr', status: 'success', details: 'Accuracy 97.3%', time: '2026-06-01 00:30:05' },
];

export const AdminPage: React.FC = () => {
  const [filterStatus, setFilterStatus] = useState('all');
  const filtered = filterStatus === 'all' ? ingestionLog : ingestionLog.filter(l => l.status === filterStatus);

  return (
    <div>
      <h4 className="fw-bold mb-4"><i className="bi bi-gear me-2"></i>Администрирование</h4>

      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <div className="metric-card">
            <div className="metric-icon bg-success bg-opacity-10 text-success"><i className="bi bi-check-circle"></i></div>
            <div className="metric-value text-success">4/4</div>
            <div className="metric-label">Сервисы онлайн</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="metric-card">
            <div className="metric-icon bg-primary bg-opacity-10 text-primary"><i className="bi bi-cpu"></i></div>
            <div className="metric-value">12%</div>
            <div className="metric-label">CPU нагрузка</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="metric-card">
            <div className="metric-icon bg-warning bg-opacity-10 text-warning"><i className="bi bi-memory"></i></div>
            <div className="metric-value">4.2 GB</div>
            <div className="metric-label">RAM использовано</div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="metric-card">
            <div className="metric-icon bg-danger bg-opacity-10 text-danger"><i className="bi bi-exclamation-triangle"></i></div>
            <div className="metric-value text-danger">1</div>
            <div className="metric-label">Ошибок за 24ч</div>
          </div>
        </div>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-lg-8">
          <div className="chart-container">
            <h6 className="fw-bold mb-3">Статистика воркеров (24ч)</h6>
            <Bar data={workerStats} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'top' } }, scales: { y: { beginAtZero: true, grid: { color: '#f1f5f9' } }, x: { grid: { display: false } } } }} height={250} />
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white">
              <h6 className="fw-bold mb-0">Очереди Redis</h6>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span className="text-muted">ingestion</span>
                <span className="badge bg-success">0</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span className="text-muted">ocr</span>
                <span className="badge bg-warning text-dark">3</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span className="text-muted">nlp</span>
                <span className="badge bg-warning text-dark">2</span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2">
                <span className="text-muted">index</span>
                <span className="badge bg-success">0</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table-card">
        <div className="table-card-header">
          <h5><i className="bi bi-journal-text me-2 text-primary"></i>Лог ingestion</h5>
          <div className="btn-group btn-group-sm">
            <button className={`btn ${filterStatus === 'all' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setFilterStatus('all')}>Все</button>
            <button className={`btn ${filterStatus === 'success' ? 'btn-success' : 'btn-outline-secondary'}`} onClick={() => setFilterStatus('success')}>Успешно</button>
            <button className={`btn ${filterStatus === 'processing' ? 'btn-warning' : 'btn-outline-secondary'}`} onClick={() => setFilterStatus('processing')}>В процессе</button>
            <button className={`btn ${filterStatus === 'error' ? 'btn-danger' : 'btn-outline-secondary'}`} onClick={() => setFilterStatus('error')}>Ошибки</button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Время</th>
                <th>Источник</th>
                <th>EO</th>
                <th>Действие</th>
                <th>Детали</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((log) => (
                <tr key={log.id}>
                  <td style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>{log.time}</td>
                  <td style={{ fontSize: '13px' }}>{log.source}</td>
                  <td className="font-monospace" style={{ fontSize: '13px' }}>{log.eo}</td>
                  <td><span className="badge bg-light text-dark" style={{ fontSize: '11px' }}>{log.action}</span></td>
                  <td style={{ fontSize: '13px', color: '#64748b' }}>{log.details}</td>
                  <td>
                    {log.status === 'success' && <span className="badge bg-success"><i className="bi bi-check-circle me-1"></i>Успешно</span>}
                    {log.status === 'processing' && <span className="badge bg-warning text-dark"><i className="bi bi-hourglass-split me-1"></i>В процессе</span>}
                    {log.status === 'error' && <span className="badge bg-danger"><i className="bi bi-x-circle me-1"></i>Ошибка</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
